/**
 * package: com.inq.ui
 * class: TextField
 * root Object
 * @constructor
 */
com.inq.ui.TextField = function() {
};
$hxClasses.registerClass(com.inq.ui.TextField, "com.inq.ui.TextField");
/** @type {com.inq.ui.TextField} */
com.inq.ui.TextField.prototype.__class__ = com.inq.ui.TextField;
